import { WorkFlowTypes } from '../../constants/WorkFlowTypes';

export type NavigationCardId =
	| 'manage-workflows'
	| 'application-management'
	| 'user-dashboard'
	| 'task-dashboard';

export interface NavigationCardItem {
	id: NavigationCardId;
	label: string;
	description: string;
	href: string;
	gradient: string;
}

export const NAVIGATION_CARDS: NavigationCardItem[] = [
	{
		id: 'manage-workflows',
		label: 'Manage Workflows',
		description: 'Create, view, edit, and delete the workflow definitions.',
		href: '/manageWorkflows',
		gradient: 'linear-gradient(135deg, #0f1b2d 0%, #1a3a5c 100%)',
	},
	{
		id: 'application-management',
		label: 'Application Management',
		description:
			'Register and manage applications, operations, and service integrations.',
		href: '/applicationManagement',
		gradient: 'linear-gradient(135deg, #00b4d8 0%, #90e0ef 100%)',
	},
	{
		id: 'user-dashboard',
		label: 'SNOW Dashboard',
		description:
			'Visual overview of the submitted requests for all workflows at a glance.',
		href: '/dashboard',
		gradient: 'linear-gradient(135deg, #7b2ff7 0%, #c084fc 100%)',
	},
	{
		id: 'task-dashboard',
		label: 'Task Dashboard',
		description:
			'View all running, pending, and failed tasks across the workflows.',
		href: '/taskDashboard',
		gradient: 'linear-gradient(135deg, #232f3e 0%, #37475a 100%)',
	},
];

export const ENTITY_TYPES: Array<{ label: string; value: string }> =
	Object.keys(WorkFlowTypes).map((key) => ({
		label: (WorkFlowTypes as Record<string, string>)[key],
		value: (WorkFlowTypes as Record<string, string>)[key],
	}));

export const WORKFLOW_ROUTES: Record<string, string> = {
	[WorkFlowTypes.P2R]: '#/launchP2RWorkflow',
	[WorkFlowTypes.RAD]: '#/launchRadWorkflow',
	[WorkFlowTypes.DOCK_MASTER]: '#/launchDockmasterWorkflow',
};

export const DASHBOARD_ROUTES: Record<string, string> = {
	task_dashboard: '#/taskDashboard',
	reconfiguration_dashboard: '#/entitySearch?workflowType=FC_RECONFIG_WORKFLOW',
	node_address_update_dashboard:
		'#/entitySearch?workflowType=NODE_ADDRESS_UPDATE_WORKFLOW',
	alert_nodes_dashboard: '#/alertNodesDashboard',
	snow_dashboard: 'https://snow.amazon.com/nodes',
};

export const DASHBOARD_OPTIONS = [
	{ label: 'Task Dashboard', value: 'task_dashboard' },
	{ label: 'Alert Nodes Dashboard', value: 'alert_nodes_dashboard' },
	{ label: 'SNOW Legacy Dashboard', value: 'snow_dashboard' },
	{ label: 'Reconfiguration Dashboard', value: 'reconfiguration_dashboard' },
	{
		label: 'Node Address Update Dashboard',
		value: 'node_address_update_dashboard',
	},
];

export const DEFAULT_WORKFLOW_URL = 'https://snow.amazon.com/nodes/new';
